import { Component, Mixins } from "vue-property-decorator";
import { IClient, IClientAddress } from "@/models/clients";
import { DataModules } from "@/store/modules/data";
import { mapState } from "vuex";
import RequestPromises from "@/mixins/requestPromises";
import { ActionTypes } from "@/data/enums";

@Component({
  computed: {
    ...mapState({
      dataScope(state, getters) {
        return getters[`data/${DataModules.CLIENTS_ADDRESSES}/clientScope`](
          this.clientId
        );
      },
      clientAddresses(state, getters) {
        return this.$_.orderBy(
          getters[`data/listArray`]({
            storeModule: DataModules.CLIENTS_ADDRESSES,
            scope: this.dataScope
          }),
          ["created_at", "asc"]
        );
      }
    })
  }
})
export default class ClientAddressesMixin extends Mixins(RequestPromises) {
  // Data
  public isLoadingClientAddresses = false;
  public dataScope!: string;
  public clientAddresses!: IClientAddress[];

  // Methods
  public async getClientAddresses({ clientId }) {
    try {
      this.isLoadingClientAddresses = true;
      return await this.$store.dispatch(
        `data/${DataModules.CLIENTS_ADDRESSES}/list`,
        {
          id: clientId,
          scope: this.dataScope,
          ignoreStored: true,
          vm: this
        }
      );
    } catch (error) {
      this.$store.dispatch("api/handleError", error);
    } finally {
      this.isLoadingClientAddresses = false;
    }
  }

  public openAddressModal({
    clientId,
    address = {} as IClientAddress,
    actionType = ActionTypes.UPDATE,
    searchedValue = "",
    config = {}
  }: {
    clientId: IClient["id"];
    address?: IClientAddress;
    actionType: ActionTypes;
    searchedValue?: string;
    config: any;
  }) {
    const props = this.$_.merge(
      { clientId },
      this.$_.isEmpty(address)
        ? {}
        : {
            data: this.$_.pick(address, [
              "name",
              "address_1",
              "address_2",
              "country_id",
              "region_id",
              "city",
              "postcode",
              "type"
            ]),
            actionType,
            addressId:
              actionType === ActionTypes.UPDATE ? address.id : undefined
          },
      searchedValue ? { searchedValue } : {}
    );

    return this.$store.dispatch(
      `data/${DataModules.CLIENTS_ADDRESSES}/openAddressModal`,
      this.$_.merge(
        {
          props
        },
        config
      )
    );
  }

  public binClientAddresses() {
    this.$store.dispatch("data/binList", {
      storeModule: DataModules.CLIENTS_ADDRESSES,
      scope: this.dataScope,
      vm: this
    });
  }
}
